import { Component, Input, OnInit } from '@angular/core';
//import { CurrencyInterface } from '@tech-interfaces/currency.interface';
import { CommonService } from '@tech-services/common.service';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import AutoNumeric from 'autonumeric';
import { AppConfig } from '@tech-utils/app-config.service';
import { TranslateService } from '@ngx-translate/core';

import { UntypedFormGroup } from '@angular/forms';
import { CurrenciesInterfaceResponse } from '@techrules/portallib';
import {
  CurrencyPipe,
  CurrencyDataPipe,
  CurrencyDataModel,
  CurrencyDataInterface,
} from '@techrules/pipelib';
import { SimulationObjInterface } from '@techrules/portallib';
import { TechDialogsService } from '../../../../shared/tech-dialogs.service';

@Component({
  selector: 'tech-simulation-data-init',
  templateUrl: './simulation-data-init.component.html',
  styleUrls: ['./simulation-data-init.component.scss'],
})
export class SimulationDataInitComponent implements OnInit {
  @Input() simulationData: UntypedFormGroup;
  private unsubscribe$ = new Subject<void>();
  private simulationObj: SimulationObjInterface;
  public initalcontribution: string;
  private keyupInitialAmount$: Subject<string> = new Subject();
  private maximumValue: string = '100000000';
  public autonumericOptions: AutoNumeric.Options = {
    digitGroupSeparator: '',
    decimalCharacter: '',
    decimalCharacterAlternative: '.',
    currencySymbol: '',
    currencySymbolPlacement: 'p',
    roundingMethod: 'U',
    minimumValue: '0',
    maximumValue: this.maximumValue,
    allowDecimalPadding: false,
    decimalPlaces: 0,
  };
  public currencyBase: string;
  public currencies: any = [];
  public minimumInvest: number = 0;
  public errorMinimun: boolean = false;
  public baseCurrency: string;
  public baseCurrencyData: CurrencyDataInterface;
  public showExchange: boolean = false;
  public exchangeTest: string;

  constructor(
    private commonService: CommonService,
    private initcontributionService: InitcontributionService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private currencySymbolPipe: CurrencyPipe,
    private currencyDataPipe: CurrencyDataPipe
  ) {}

  ngOnInit() {
    this.formatAutonumeric(AppConfig.settings.currencyBase);

    this.initcontributionService.evalGoalObj$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        if (Object.keys(res).length !== 0) {
          this.initcontributionService
            .getModelPortfolio()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res) => {
              this.minimumInvest = res.MinimumInvest;
            });
        }
      });

    this.initcontributionService
      .getCurrencies()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: CurrenciesInterfaceResponse) => {
        this.currencies = res.currencies;
        this.baseCurrency = res.baseCurrency;
        this.baseCurrencyData = new CurrencyDataModel(
          this.currencyDataPipe.transform(this.baseCurrency)
        );
        this.simulationData
          .get('investCurrency')
          .setValue(this.currencies[0].code);
        this.formatAutonumeric(this.simulationData.value.investCurrency);
      });

    setTimeout(() => {
      if (localStorage.getItem('SimulationObj') != null) {
        AutoNumeric.getAutoNumericElement(
          document.getElementById('inicialAmount')
        ).set(
          JSON.parse(localStorage.getItem('SimulationObj'))
            .InitialContributionAmount
        );
        this.simulationObj.InitialContributionAmount = Number(
          JSON.parse(localStorage.getItem('SimulationObj'))
            .InitialContributionAmount
        );
        this.initcontributionService.simulationObjSource.next(
          this.simulationObj
        );
      }
    });

    this.initcontributionService.simulationObj$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: SimulationObjInterface) => {
        this.simulationObj = data;
        setTimeout(() => {
          if (data.InitialContributionAmount == 0) {
            AutoNumeric.getAutoNumericElement(
              document.getElementById('inicialAmount')
            ).set('0');
          }
        });
      });

    this.keyupInitialAmount$
      .pipe(
        map((e: any) => e.currentTarget),
        debounceTime(1500)
      )
      .subscribe((res) => {
        if (res.value.indexOf('-') == -1) {
          if (res.value == '') {
            this.simulationObj.InitialContributionAmount = 0;
            AutoNumeric.getAutoNumericElement(res).set(0);
            this.initcontributionService.simulationObjSource.next(
              this.simulationObj
            );
          } else {
            this.simulationObj.InitialContributionAmount =
              AutoNumeric.getAutoNumericElement(res).getNumber();
            this.initcontributionService.simulationObjSource.next(
              this.simulationObj
            );
            if (
              this.minimumInvest >
              AutoNumeric.getAutoNumericElement(res).getNumber()
            ) {
              this.initcontributionService.errorMinimunSource.next(true);
            } else {
              this.initcontributionService.errorMinimunSource.next(false);
            }
            this.exchangeRate();
          }
        } else {
          AutoNumeric.getAutoNumericElement(res).set(
            res.value.replace('-', '')
          );
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public keyupInitiaAmount(event) {
    if (event.target.value.indexOf('-') == -1) {
      this.keyupInitialAmount$.next(event);
    } else {
      AutoNumeric.getAutoNumericElement(
        document.getElementById('inicialAmount')
      ).set(0);
      this.simulationObj.InitialContributionAmount = 0;
      this.initcontributionService.simulationObjSource.next(this.simulationObj);
    }
  }

  public viewHintHelp(event) {
    let text1: string;
    this.translate.get('k002779').subscribe((text: string) => {
      text1 = text; //Token: Tu banco emisor
    });
    let text2: string;
    this.translate.get('k002780').subscribe((text: string) => {
      text2 = text; //Token:Es importante incluir tu banco emisor desde el que efectuarás la transferencia de fondos, ya que la información facilitada nos ayudará a relacionar tu notificación de depósito con los fondos depositados.
      this.dialogService.openModalDialog('', text1, text2, '');
    });
  }

  public formatAutonumeric(currency) {
    this.autonumericOptions = {
      decimalCharacterAlternative: '.',
      roundingMethod: 'U',
      minimumValue: '0',
      maximumValue: this.maximumValue,
      allowDecimalPadding: false,
      showWarnings: false,
      decimalPlaces: 0,
    };
    let currencyData: CurrencyDataInterface = new CurrencyDataModel(
      this.currencyDataPipe.transform(currency)
    );
    //Formateamos el autonumeric
    this.autonumericOptions.currencySymbol = ' ' + currencyData.symbol + ' ';
    this.autonumericOptions.currencySymbolPlacement =
      currencyData.symbolPosition == 'L' ? 'p' : 's';
    this.autonumericOptions.decimalCharacter = currencyData.decimalSeparator;
    this.autonumericOptions.digitGroupSeparator = currencyData.groupSeparator;
  }

  public changeCurrency(event) {
    this.initcontributionService.currencyContributionSource.next(event);
    this.formatAutonumeric(event);
    this.exchangeRate();
  }

  public exchangeRate() {
    if (this.simulationData.value.investCurrency == this.baseCurrency) {
      this.showExchange = false;
      this.errorMinimun =
        this.simulationObj.InitialContributionAmount >= this.minimumInvest
          ? false
          : true;
    } else if (this.simulationObj.InitialContributionAmount !== 0) {
      this.showExchange = true;
      this.currencies.forEach((currency) => {
        if (currency.code == this.simulationData.value.investCurrency) {
          let contribution =
            this.simulationObj.InitialContributionAmount *
            currency.exchangeRate;
          this.exchangeTest = this.currencySymbolPipe.transform(
            contribution,
            this.baseCurrencyData.symbol
          );
          this.errorMinimun = contribution >= this.minimumInvest ? false : true;
          this.initcontributionService.errorMinimunSource.next(
            contribution >= this.minimumInvest ? false : true
          );
        }
      });
    } else {
      this.showExchange = false;
    }
  }

  public mousewheel(event) {
    event.target.blur();
  }
}
